import { useState } from 'react';

const useFilters = () => {
  const [isOpen, setOpen] = useState(false);

  function toggleFilter() {
    setOpen(!isOpen);
  }

  return {
    isOpen,
    toggleFilter,
  };
};

export default useFilters;
